<template>
  <div class="page-footer">
    <template v-if="backAction">
      <div class="footer__back" @click="backAction.action()">
        <svgicon src="icon/arrow.svg" :height="14" :width="12"></svgicon>
        <div class="text">
          {{backAction.text || $t("back")}}
        </div>
      </div>
    </template>
    <div class="filler"></div>
    <template v-if="secondaryActions && secondaryActions.length > 0">
      <button class="btn btn-secondary" v-for="secondaryAction of secondaryActions" @click="secondaryAction.action()">
        {{secondaryAction.text}}
      </button>
      <div class="dash" v-if="mainAction"></div>
    </template>
    <template v-if="mainAction">
      <button class="btn btn-primary" @click="mainAction.action()">
        {{mainAction.text}}
      </button>
    </template>
  </div>
</template>

<script>
  export default {
    name: "PageFooter",

    props: {
      backAction: Object, /** {{action: Function, text: String}} */
      mainAction: Object, /** {{action: Function, text: String}} */
      secondaryActions: Array /** {{action: Function, text: String}[]} */
    }
  }
</script>

<style lang="scss" scoped>
  .page-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    max-width: 1100px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-shrink: 0;

    .filler {
      flex-grow: 1;
    }
  }

  .dash {
    width: 1px;
    height: 16px;
    background-color: #DBDBDB;
    margin-left: 15px;
    margin-right: 15px;
  }

  .btn-secondary {
    margin-left: 10px;
  }

  .footer__back {
    font-size: 16px;
    color: var(--primary-color);
    fill: var(--primary-color);
    padding: 15px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .text {
      margin-left: 10px;
    }
    .svgicon {
      transform: rotate(90deg);
    }
  }
</style>